<template>
  <div>
    <div style="padding:6px 16px 0px 16px;">
      <el-form
          v-loading="loading"
          ref="formRef"
          :model="formValue"
          :rules="rules"
      >
        <div class="apply-title">
          <div>{{ agreeTitle }}</div>
        </div>
        <el-form-item label="备注说明" prop="comments" required>
          <el-input
              type="textarea"
              v-model="formValue.comments"
              placeholder="请输入"
              maxlength="255"
              rows="4"
              show-word-limit
          />
        </el-form-item>
<!--        <el-form-item v-if="processInfo.signFlag" label="签名画板" prop="signInfo" :required="processInfo.signFlag">-->
<!--          <vue-esign ref="esignRef" :width="800" :height="300" />-->
<!--          <el-button-->
<!--              v-if="!formValue.signInfo"-->
<!--              size="mini"-->
<!--              type="primary"-->
<!--              @click="handleGenerate"-->
<!--          >生成图片</el-button>-->
<!--          <el-button size="mini" type="warning" @click="handleReset">清空画板</el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <image-upload @choiceImages="choiceImages" v-model="formValue.imageList"/>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <file-upload v-model="formValue.fileList"/>-->
<!--        </el-form-item>-->
      </el-form>
    </div>
    <div style="display: flex;justify-content: end">
      <el-button size="small" type="success" plain @click="$emit('close')">取 消</el-button>
      <el-button size="small" type="success" :loading="loading" @click="handleConfirm">{{ agreeButtonText }}</el-button>
    </div>
  </div>
</template>

<script>
import { agree } from "@/api/oa/audit.js";
import ImageUpload from "./ImageUpload";

export default {
  name: "AgreeModal",
  components: { ImageUpload },
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    processInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      formValue: {
        comments: "",
        imageList: [],
        fileList: [],
        signInfo: "",
      },
      rules: {
        comments: [
          { required: true, message: "请填写审批意见", trigger: "blur" },
        ],
        signInfo: [{ required: this.processInfo.signFlag, message: "请签名", trigger: "blur" }],
      },
    };
  },
  created() {
    console.log(this.processInfo)
  },
  computed: {
    // 当前节点类型：TASK=办理节点，APPROVAL=审批节点
    currentNodeType() {
      return this.processInfo?.currentNode?.type || "";
    },
    isTaskNode() {
      return this.currentNodeType === "TASK";
    },
    // 标题：办理节点显示"办理申请"，审批节点保持"同意申请"
    agreeTitle() {
      return this.isTaskNode ? "办理申请" : "同意申请";
    },
    // 按钮文案：办理节点显示"办 理"，审批节点保持"同 意"
    agreeButtonText() {
      return this.isTaskNode ? "办 理" : "同 意";
    },
    show: {
      get() {
        return this.visible;
      },
      set(visible) {
        this.$emit("update:visible", visible);
      },
    },
  },
  methods: {
    choiceImages(val){
      this.formValue.imageList = val;
    },
    handleReset() {
      //清空画布
      this.$refs.esignRef.reset();
      this.formValue.signInfo = "";
    },
    handleGenerate() {
      this.$refs.esignRef
        .generate()
        .then((res) => {
          // 得到了签字生成的base64图片
          this.formValue.signInfo = res;
          this.$message("生成成功");
        })
        .catch(() => {
          //  没有签名，点击生成图片时调用
          this.$message("未签名！");
        });
    },
    // 确认操作
    handleConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        const { imageList, fileList, signInfo, ...restParams } = this.formValue;
        const params = {
          ...this.processInfo,
          ...restParams,
          attachments: [...imageList, ...fileList],
        };
        if(this.processInfo.signFlag) {
          params.signInfo = signInfo;
        }
        this.loading = true;
        agree(params).then(() => {
            this.$message.success("操作成功");
            this.handleCancel();
            // 成功事件交给父组件统一处理（关闭弹层、返回上一页等）
            this.$emit("success");
            this.$emit('close')
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    // 取消操作
    handleCancel() {
      this.$refs.formRef.resetFields();
      this.formValue = {
        comments: "",
        imageList: [],
        fileList: [],
        signInfo: "",
      };
      this.show = false;
      this.$emit('cancel');
    },
  },
};
</script>
<style scoped>
.apply-title{
  font-weight: bold;
  font-size: 15px;
  text-align: center;
}
</style>
